import React from 'react';
import './Spinner.scss';

export const Spinner: React.FC = () => (
  <div className="spinner-container">
    <div className="spinner" />
  </div>
);
